import moment from "moment";

export function formatDate(date: moment.Moment) {
  return date.format("yyyy-MM-DD HH:mm:ss");
}

export function getToday() {
  return moment().startOf("day");
}
